import { createLocale } from "react-localized";
import messages from "./messages/fr.po";

const extra = {};

export default createLocale(messages, extra);
